var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_3029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 9.84008V2.33341C9.33329 1.89139 9.1577 1.46746 8.84514 1.1549C8.53258 0.842343 8.10865 0.666748 7.66663 0.666748C7.2246 0.666748 6.80068 0.842343 6.48811 1.1549C6.17555 1.46746 5.99996 1.89139 5.99996 2.33341V9.84008C5.46481 10.1976 5.05884 10.7178 4.84201 11.3238C4.62517 11.9298 4.60897 12.5894 4.7958 13.2053C4.98262 13.8212 5.36257 14.3607 5.87952 14.7441C6.39647 15.1275 7.02302 15.3345 7.66663 15.3345C8.31024 15.3345 8.93678 15.1275 9.45374 14.7441C9.97069 14.3607 10.3506 13.8212 10.5375 13.2053C10.7243 12.5894 10.7081 11.9298 10.4912 11.3238C10.2744 10.7178 9.86844 10.1976 9.33329 9.84008Z",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_3029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.78dfad135196e7e31d88b0f139deb293.svg";
export { ForwardRef as ReactComponent };